const hospitals = [
    {
        "code": "0012",
        "name": "台大醫院",
        "invoiceTitle": "收據",
        "taxIdNo": "12345678",
        "address": "台北市中正區中山南路7號",
        "testItem": "test1",
        "activatedOn": "2018/06/03",
        "referral": "ourHospital",
        "participants": [
            {
                "role": "host",
                "name": "王孝明",
                "unit": "111",
                "jobTitle": "醫生",
                "activatedOn": "2018/06/03"
            }
        ]
    },
    {
        "code": "0024",
        "name": "亞東醫院",
        "invoiceTitle": "收據",
        "taxIdNo": "15678234",
        "address": "新北市板橋區南雅南路二段21號",
        "testItem": "test2",
        "activatedOn": "2018/03/03",
        "expiredOn": "2021/08/21",
        "referral": "referredOut",
        "hospitalName": "台大醫院",
        "participants": [
            {
                "role": "host",
                "name": "王惠明",
                "unit": "111",
                "jobTitle": "護理師",
                "activatedOn": "2018/06/03"
            },
            {
                "role": "doctor",
                "name": "王孝明",
                "unit": "222",
                "jobTitle": "醫生",
                "activatedOn": "2015/05/03",
                "phone": "0912221112",
                "email": "ming1234@gmail.com"
            }
        ]
    },
    {
        "code": "0322",
        "name": "國泰醫院",
        "invoiceTitle": "收據",
        "taxIdNo": "12780778",
        "address": "臺北市仁愛路四段280號",
        "testItem": "test3",
        "activatedOn": "2010/06/03",
        "referral": "ourHospital",
        "participants": [
            {
                "role": "host",
                "name": "王孝明",
                "unit": "111",
                "jobTitle": "醫生",
                "activatedOn": "2010/08/03"
            }
        ]
    }
];

export default hospitals;